const DIRECTION_PREFIX_MAP = {
    'export': 'Export',
    'import': 'Import',
}

const DOMAIN_PREFIX_MAP = {
    'publishing_works': 'PublishingWorks',
    'publishing_sheets': 'PublishingSheets',
    'publishing_projects': 'PublishingProjects',
    'publishing_income': 'PublishingIncome',
    'publishing_statements': 'PublishingStatements',
    'publishing_payee_statement': 'PublishingPayeeStatement',
    'label_tracks': 'LabelTracks',
    'label_releases': 'LabelReleases',
    'label_sales_data': 'LabelSalesData',
    'label_statements': 'LabelStatements',
    'az_persons': 'AzPersons',
    'contracts_publishing': 'ContractsPublishing',
    'contracts_label': 'ContractsLabel',
}

export function getMappingHelpContext(direction, domain) {
    if (!direction || !domain) return null
    const dirPrefix = DIRECTION_PREFIX_MAP[direction]
    const domPrefix = DOMAIN_PREFIX_MAP[domain]
    if (!dirPrefix || !domPrefix) return null
    return 'AccountMappingsEdit' + dirPrefix + domPrefix
}
